/**
 * Action-required notifications: user must respond (accept/decline or equivalent)
 * before we allow mark-as-read / dismiss. Align with server cleanup of stale rows.
 */
export function isActionRequiredType(type, role) {
  if (!type) return false;
  if (type === "invite_received") return true;
  if (
    type === "join_request_received" &&
    (role === "bar_owner" || role === "bar_admin")
  ) {
    return true;
  }
  if (type === "show_pending" && role === "artist") return true;
  return false;
}

export function isNotificationGroupActionRequired(group, userRole) {
  const type = group?.latestNotification?.type;
  return isActionRequiredType(type, userRole);
}

/** Unread / badge: actionable rows count once each; other types only if unread. */
export function notificationCountsForBadge(notifications, userRole) {
  let actionRequired = 0;
  let informationalUnread = 0;

  for (const n of notifications || []) {
    if (n.type === "message_received") continue;
    if (isActionRequiredType(n.type, userRole)) {
      actionRequired += 1;
    } else if (!n.is_read) {
      informationalUnread += 1;
    }
  }

  return {
    actionRequiredCount: actionRequired,
    informationalUnreadCount: informationalUnread,
    badgeCount: actionRequired + informationalUnread,
  };
}
